import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { API, BackgroundWorkerDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { UserService } from 'src/app/services/user.service';
import { UtilService } from 'src/app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { SbSplitButton } from '../../../services/global/global-interfaces';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RequestClass } from '../../../services/global/RequestClass';
import { SbSplitButtonItem } from '@ngx-seatback/controls';

type SplitButtonAction = 'interrupt';

@Component({
  selector: 'sb-page-admin-backgroundWorker',
  templateUrl: './background-worker.component.html',
  styleUrls: ['./background-worker.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundWorkerComponent extends RequestClass {
  public readonly userStatus = inject(UserService);
  public readonly modal = inject(ModalService);
  public readonly errorHandler = inject(ErrorService);
  public readonly util = inject(UtilService);
  public readonly translate = inject(TranslateService);
  private readonly api = inject(API);
  private readonly destroyRef = inject(DestroyRef);

  // table wrapper variables
  backgroundWorker: BackgroundWorkerDTO[] = [];

  refreshFromServer() {
    const sub = this.api
      ._admin_BackgroundWorker_retrieveAll()
      .pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading.set(false);
        })
      )
      .subscribe({
        next: (worker: BackgroundWorkerDTO[]) => {
          this.backgroundWorker = this.buildSplitButtons(worker);
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    this.subs.push(sub);
  }

  buildSplitButtons<T>(itemsToAdd: T[]): (T & SbSplitButton<SplitButtonAction>)[] {
    const result = itemsToAdd.map(item => {
      return { ...item, sbButtons: [] as SbSplitButtonItem<SplitButtonAction>[] };
    });
    result.forEach(item => {
      item.sbButtons.push({
        icon: 'clock',
        action: 'interrupt',
        tooltip: 'lang.globals.interrupt',
      });
    });
    return result;
  }

  resolveSplitButtonAction(pWorker: BackgroundWorkerDTO, $event: SplitButtonAction) {
    switch ($event) {
      case 'interrupt':
        this.interruptWorker(pWorker);
        break;
      default:
        console.error('Missing action implementation of Splitbutton');
        break;
    }
  }

  interruptWorker(pWorker: BackgroundWorkerDTO) {
    this.api._admin_BackgroundWorker_interrupt(pWorker.name).subscribe({
      next: (worker: BackgroundWorkerDTO) => {
        const index = this.backgroundWorker.findIndex(workerFromArray => workerFromArray.name === worker.name);
        this.backgroundWorker[index] = worker;
      },
    });
  }
}
